import Button from 'component/atom/forms/button/Button';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Modal from 'component/hoc/modal/Modal';
import React from 'react';
import styles from './EmbeddedCode.module.scss';
import { useToast } from 'app-context/toasterContext/ToastContext';
import { botToast } from 'helpers/toastMessages';

const EmbeddedCode = ({ isOpen, onClose, item }) => {
  const toast = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(item?.scriptt);
    toast.open(botToast.copy, 'add');
  };

  return (
    <Modal title='Script' isOpen={isOpen} onClose={onClose}>
      <div className={styles.cont}>
        <TextArea value={item?.scriptt} disabled rows='18' />
        <div className={styles.buttonCont}>
          <Button label='Copy Embedded Code' onClick={handleCopy} />
        </div>
      </div>
    </Modal>
  );
};

export default EmbeddedCode;
